export const createGlobalStyle = (styleTag) => {
  styleTag.innerHTML = `
      .ant-tooltip-inner {
        color: white !important;
      }
      .center {
       text-align:center;
       width: 100%;
       height: 100%;
      }
      .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .ellipsis {
        white-space: nowrap;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
      }

    `;
};
